export enum VideoStatus {
  pending = "pending",
  processing = "processing",
  done = "done",
  error = "error",
}
